export default "__VITE_ASSET__BBwwV2hR__"